import React, { memo, useCallback, useMemo } from "react";
import colors from "app/colors";
import { ArrowDownIcon, ArrowUpIcon } from "modules/icons";
import { IconButton } from "@chakra-ui/react";

interface IProps {
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
  isExpanded: boolean;
}

const ComposeResizeInputButton = ({ setIsExpanded, isExpanded }: IProps) => {
  const icon = useMemo(() => {
    if (isExpanded) {
      return <ArrowDownIcon boxSize={8} fill={colors.gray40} />;
    }
    return <ArrowUpIcon boxSize={8} fill={colors.gray40} />;
  }, [isExpanded]);

  const onClick = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, [setIsExpanded]);

  return (
    <IconButton
      title="Add tag"
      size="xs"
      variant="ghost"
      color={colors.gray40}
      icon={icon}
      onClick={onClick}
      tabIndex={-1}
      aria-label="Add tag"
    />
  );
};

export default memo(ComposeResizeInputButton);
